import { useState } from "react";
import SectionHeader from "../SectionHeader";
import { GoPrimitiveDot } from "react-icons/go";
import { BsCheck2 } from "react-icons/bs";
import Button from "../Button";

const tabs = [
  {
    id: 1,
    text: "Wood Chair",
  },
  {
    id: 2,
    text: "Plastic Chair",
  },
  {
    id: 3,
    text: "Sofa Collection",
  },
];

const checks = [
  { id: 1, text: "Material expose like metals" },
  { id: 2, text: "Clear lines and geomatric figures" },
  { id: 3, text: "Simple neural colours." },
  { id: 4, text: "Material expose like metals" },
];

export default function DiscountItems() {
  const [currentTab, setCurrentTab] = useState(1);
  return (
    <>
      <SectionHeader>Discount Items</SectionHeader>
      <div className="flex justify-center font-fontTwo">
        {tabs.map((value) => (
          <button
            key={value.id}
            onClick={() => setCurrentTab(value.id)}
            className={`${
              currentTab === value.id ? "text-pink underline" : null
            } mx-3 hover:underline hover:text-pink`}
          >
            {value.text}
            {currentTab === value.id && (
              <GoPrimitiveDot size={10} className="inline-block ml-1" />
            )}
          </button>
        ))}
      </div>
      {currentTab === 3 && <div className=" text-center">tab 3</div>}
      {currentTab === 2 && <div className=" text-center">tab 2</div>}
      {currentTab === 1 && (
        <div className=" mx-auto max-w-5xl flex items-center h-[25rem] font-fontTwo">
          {/* left side */}
          <div className=" text-[#B7BACB] w-7/12">
            <h3 className="font-fontOne text-3xl text-text font-bold mb-2">
              20% Discount On all Products
            </h3>
            <div className="text-pink text-base font-semibold mb-4">
              Eam Sofa Compact
            </div>
            <p className="mb-3">
              Est tempor laborum incididunt laborum occaecat. Cupidatat pariatur
              veniam. Voluptate aliqua nulla proident.
            </p>
            <div className="grid grid-cols-2 mb-4">
              {checks.map((value) => (
                <div key={value.id} className="flex items-center mb-1">
                  <BsCheck2
                    className="inline-block mr-1 translate-y-[0.15rem]"
                    color="#7569B2"
                    size={20}
                  />
                  {value.text}
                </div>
              ))}
            </div>
            <Button color="pink">Shop Now</Button>
          </div>
          {/* right side */}
          <div className=" h-full w-5/12 flex items-center justify-center">
            <div className=" w-full h-full relative flex justify-center items-center">
              <div className="bg-[#FCECF1] rounded-full w-80 h-80"></div>
              <img
                className=" absolute w-full scale-[1.17]"
                alt=""
                src={require("../../assets/home/discount-items/img01.png")}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
